import styled from 'styled-components';
import {typographyStyles} from '../../utils/styles';

const StyledCircleIconButtonIcon = styled.div`
  align-items: center;
  background-color: ${props => props.theme.colors.neutral_1};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  height: 30px;
  margin-right: 8px;
  transition: .2s ease-in;
  width: 30px;
  
  svg {
    height: 16px;
    width: 16px;
    
    path {
      fill: ${props => props.theme.colors.primary_6};
      transition: .2s ease-in;
    }
  }
`;

const StyledCircleIconButton = styled.div`
  ${typographyStyles.body.regular};
  
  background-color: unset;
  color: #000;
  align-items: center;
  display: flex;
  padding: 0;
  
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'default')};
  
  ${StyledCircleIconButtonIcon} {
    background-color: ${props => props.disabled ? 'transparent !important' : props.theme.colors.neutral_1};
  }
  
  &:hover {
    cursor: pointer;
    
    ${StyledCircleIconButtonIcon} {
      background-color: ${props => props.theme.colors.primary_2};
    }
  }
`;

export {
  StyledCircleIconButton,
  StyledCircleIconButtonIcon,
}